// @flow
import { execute }        from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

import closeEsp         from 'fg-frontend/webActions/closeEsp';
import goBack           from 'fg-frontend/webActions/goBack';
import scrollToHref     from 'fg-frontend/webActions/scrollToHref';
import confirmPopup     from 'fg-frontend/webActions/confirmPopup';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import replaceHistory from 'fg-frontend/webActions/replaceHistory';
import printPage from 'fg-frontend/webActions/printPage';
import postCodeValidation from './webActions/postCodeValidation';
import executeAndClose from 'fg-frontend/webActions/executeAndClose';
import targetClick from 'fg-frontend/webActions/targetClick';
import cancelSearchForm from './webActions/cancelSearchForm';
import pushDataLayer from './webActions/pushDataLayer';

import configureEshopActions from './configureEshopActions';

export default (action) => {
	switch (action) {
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'executeAndClose':
			return executeAndClose;
		case 'targetClick':
			return targetClick;
		case 'goBack':
			return goBack;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
		case 'toggleClass':
			return toggleClass;
		case 'printPage':
			return printPage;
		case 'replaceHistory':
			return replaceHistory;
		case 'postCodeValidation':
			return postCodeValidation;
		case 'cancelSearchForm':
		  return cancelSearchForm;
		case 'pushDataLayer':
		  return pushDataLayer;
		default:
			const eshopAction = configureEshopActions(action);
			if (eshopAction) {
				return eshopAction;
			}
			else {
				console.log(`Unknown action`, action);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js